export default __webpack_public_path__ + "static/media/banner_transfer.0db980f0.jpg";